var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5457",
    "data-name": "Group 5457",
    transform: "translate(-1193 -360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "question-circle-Filled_1_",
    d: "M278,2555a25,25,0,1,0,25,25A25.041,25.041,0,0,0,278,2555Z",
    transform: "translate(940 -2195)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(1206 373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "question-circle-Filled_1_2",
    "data-name": "question-circle-Filled_1_",
    d: "M270.5,2555a17.5,17.5,0,1,0,17.5,17.5A17.529,17.529,0,0,0,270.5,2555Zm0,28a1.75,1.75,0,1,1,1.75-1.749A1.754,1.754,0,0,1,270.5,2583Zm3.57-8.189c-1.61,1.068-1.872,1.645-1.907,1.75a1.744,1.744,0,0,1-1.663,1.19,2.074,2.074,0,0,1-.56-.087,1.776,1.776,0,0,1-1.1-2.222,8.025,8.025,0,0,1,3.29-3.553c2.187-1.453,1.907-3.028,1.82-3.535a3.55,3.55,0,0,0-2.8-2.8A3.506,3.506,0,0,0,267,2569a1.75,1.75,0,1,1-3.5,0,6.968,6.968,0,0,1,2.5-5.354,6.992,6.992,0,0,1,11.393,4.095A6.837,6.837,0,0,1,274.07,2574.81Z",
    transform: "translate(948 -2187)",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.35484909275ba951c581f4baa6cbb13e.svg";
export { ForwardRef as ReactComponent };